import React from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { Grid, Card, CardContent, CardActionArea, CardMedia, Tooltip, Typography } from '@mui/material';
import { folderImg } from '../../constant';

function Folder(props)
{
	const {projectName,id,zone,onZoneClick} = props;
	return (
	<Grid key={id} item xs={2}>
		<Card onClick={onZoneClick(projectName, zone)}>
			<CardActionArea>
				<CardMedia
					component={"img"}
					alt="picture"
					image={folderImg}
				/>
			</CardActionArea>
			<CardContent sx={{ backgroundColor: "#f3f1f1" }}>
				<Tooltip title={id}>
					<Typography noWrap textOverflow={"ellipsis"} sx={{ whiteSpace: "nowrap", fontSize: "12px", textAlign: "center" }}>
						{/* <Box sx={{ whiteSpace: "nowrap", fontSize: "12px", textAlign: "center" }}>
							{doc.zone}
						</Box> */}
						{zone}
					</Typography>
				</Tooltip>
			</CardContent>
		</Card>
	</Grid>
	);
}

// When users click a project, it renders Folder page
export default function FolderPage() {
	const { zones, searchValue } = useOutletContext();
	const { projectName } = useLocation().state;
	const navigate = useNavigate();

	const onZoneClick = (projectName, zone) => () => navigate(`/home/project/${encodeURIComponent(projectName)}/zone/${encodeURIComponent(zone)}`, { state: { projectName, zone, searchValue } });
	return (
		<Grid container spacing={3}>
			<Folder projectName={projectName} id={"All"} zone={"All Zones"} onZoneClick={onZoneClick} key={"All"}/>
			{
				zones.filter(zone => {return zone.project === projectName}).filter(doc => {
					if (searchValue === "")
						return true;
					else if (doc.zone.toLowerCase().includes(searchValue.toLowerCase()))
						return true;
					return false;
				}).map(doc =>
					<Folder projectName={projectName} id={doc.id} zone={doc.zone} onZoneClick={onZoneClick} key={doc.id}/>
					// <Grid key={doc.id} item xs={2}>
					// 	<Card onClick={onZoneClick(projectName, doc.zone)}>
					// 		<CardActionArea>
					// 			<CardMedia
					// 				component={"img"}
					// 				alt="picture"
					// 				image={folderImg}
					// 			/>
					// 		</CardActionArea>
					// 		<CardContent sx={{ backgroundColor: "#f3f1f1" }}>
					// 			<Tooltip title={doc.id}>
					// 				<Typography noWrap textOverflow={"ellipsis"} sx={{ whiteSpace: "nowrap", fontSize: "12px", textAlign: "center" }}>
					// 					{/* <Box sx={{ whiteSpace: "nowrap", fontSize: "12px", textAlign: "center" }}>
					// 						{doc.zone}
					// 					</Box> */}
					// 					{doc.zone}
					// 				</Typography>
					// 			</Tooltip>
					// 		</CardContent>
					// 	</Card>
					// </Grid>
				)
			}
		</Grid>
	)
}
